import { assocPath, curry, pathOr, reduce } from "ramda";
import { HighlightedCell } from "../highlightedCells/types";
import { AccountId, SpreadPeriodIndex, SpreadSheetType } from "../spread/types";

interface HighlightedCellMap {
  [spreadSheetType: string]: {
    [accountId: string]: { [period: string]: boolean };
  };
}

export const buildHighlightedCellMap: (
  highlightedCells: HighlightedCell[]
) => HighlightedCellMap = reduce(
  (acc, highlightedCell: HighlightedCell) =>
    assocPath(
      [
        highlightedCell.spreadSheetType,
        highlightedCell.accountId,
        highlightedCell.period
      ],
      true,
      acc
    ),
  {}
);

export const isCellHighlighted = curry(
  (
    highlightedCellMap: HighlightedCellMap,
    spreadSheetType: SpreadSheetType,
    accountId: AccountId,
    period: SpreadPeriodIndex
  ): boolean =>
    pathOr(false, [spreadSheetType, accountId, period], highlightedCellMap)
);



// WEBPACK FOOTER //
// ./src/spread/model/highlightedCells/highlightedCellMap.ts